export default "/images/brand-item.png?52a5edf12cf050d50439045f99f1baec";